export const REQUEST_FEED = 'zola/feed/REQUEST_FEED';
export const RECEIVE_FEED = 'zola/feed/RECEIVE_FEED';
export const RESET_FEED = 'zola/feed/RESET_FEED';
export const MARK_AS_READ = 'zola/feed/MARK_AS_READ';
export const MARK_AS_SEEN = 'zola/feed/MARK_AS_SEEN';
